import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { provideApolloClient } from "@vue/apollo-composable";
import { onError } from "@apollo/client/link/error";

export default defineNuxtPlugin((nuxtApp) => {
  const toast = useToast(); // Toast composable
  /*
  nuxtApp.hook("apollo:error", (error) => {
    
    toast.add({ title: "Apollo Error occured, see console." });
    console.log("Apollo Error from Plugin");
    console.error(error);

    // Handle different error cases
  });
  */

  //console.log("Apollo Plugin Loaded");
  //console.dir(nuxtApp, { depth: null });

  const session = useSession(); // Session composable
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        "X-Parse-Application-Id": "lu.land.app", // Parse App ID
        "X-Parse-Session-Token": session.session.value, // Parse Session Token
      },
    };
  });
  //const httpLink = new HttpLink({ uri: nuxtApp.$config.public.GQL_HOST }); // classic http link
  const uploadLink = createUploadLink({ uri: nuxtApp.$config.public["graphql-client"].clients.default.host });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );

    if (networkError) console.log(`[Network error]: ${networkError}`);

    toast.add({ title: "Apollo Error occured, see console." });
  });

  const apolloClient = new ApolloClient({
    link: errorLink.concat(authLink.concat(uploadLink)),
    cache: new InMemoryCache(),
  });

  nuxtApp._apolloClients.default = apolloClient;
  provideApolloClient(apolloClient);
});
